import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom";
import { IWidgetComponent } from "./IWidgetComponent";
import { MsoTable } from "../../Table/MsoTable";
import { EditTypes } from "../../Table/EditTypes";
import { app } from "../../../Frame/App";
import { LanguageString } from "../../../Model/LanguageString";
import { TableColumnTypes } from "../../Table/TableColumnTypes";
import { ITableColumn } from "../../Table/ITableColumn";
import { TableColumnAlign } from "../../Table/TableColumnAlign";
import { WidgetNewestDocuments } from "../Widgets/WidgetNewestDocuments";


export type WidgetNewestDocumentsComponentProps = {
    widget: WidgetNewestDocuments;
    title: LanguageString;
    fixedLayout?: boolean;
    settingsName?: string;
}

export class WidgetNewestDocumentsComponent extends JSXComponent implements IWidgetComponent {
    props: WidgetNewestDocumentsComponentProps;
    table: MsoTable;

    availableColumns: ITableColumn[] = [
        {
            type: TableColumnTypes.Custom,
            headerText: "Download",
            dataField: "download",
            number: 1,
            align: TableColumnAlign.Center,
            width: 70
        }, {
            type: TableColumnTypes.String,
            headerText: "Bemerkung",
            dataField: "bemerkung",
            number: 1,
            width: 150
        }, {
            type: TableColumnTypes.String,
            headerText: "Kommentar",
            dataField: "kommentar",
            number: 1,
            width: 150
        }, {
            type: TableColumnTypes.String,
            headerText: "Maßnahme Status",
            dataField: "massnahmeStatus",
            number: 1,
            width: 200
        }, {
            type: TableColumnTypes.String,
            headerText: "Dateiname",
            dataField: "dateiname",
            number: 1,
            width: 300
        }, {
            type: TableColumnTypes.String,
            headerText: "Link",
            dataField: "link",
            number: 1,
            width: 200
        }
    ];

    constructor(props: WidgetNewestDocumentsComponentProps) {
        super(props);
    }

    public element: HTMLElement;
    private getElement = () => {
        return <div className="widget Background-Blur-90-MSO widget-generic-data-table">
            <div className="title-row">
                <div className="title mr-auto">{(this.props.title[`value${app.languageUpperCase}`] && this.props.title[`value${app.languageUpperCase}`].trim().length > 0) ? this.props.title[`value${app.languageUpperCase}`] : this.props.title[`value${app.defaultLanguageUpperCase}`]}</div>
                {/*<div>Button Spalten bearbeiten hier</div>*/}
            </div>
            <div className="content-row">
                <div className="mso-table">
                    {this.renderTable()}
                </div>
            </div>
        </div>;
    }

    loadAndCreate = () => {
        $.ajax({
            url: app.resolveUrl("~/api/documents/getNewestDocuments"),
            method: "GET",
            success: (response) => {

                console.log(response);

                if (Array.isArray(response)) {
                    this.table.createAll(this.availableColumns as ITableColumn[], response, "widget_generic_data_test", "id", true, false, null, null, true);
                } else {
                    console.log(response);
                }
            },
            error: (err) => {
                console.log(err);
            }
        });
    }

    renderTable(): HTMLElement {

        let rootId = "widget_" + app.createGuid();
        let div: HTMLElement = <div id={rootId} className="mso-table" ></div >;

        this.table = new MsoTable(div, {
            loadOnCreate: false,
            enableScroll: true,
            enableSort: true,
            enableFilterPopup: true,
            fixedLayout: this.props.fixedLayout,
            fixedHeader: true,
            editType: EditTypes.None,
            viewIndex: 42,
            rowClickUrlUsePopup: true,
            settingsName: this.props.settingsName,
            getCustomContent: (field: string, model: any) => {
                let element: HTMLElement = <i className="dl-button fa fa-download"></i>
                element.addEventListener("click", (event: Event) => {
                    let fakeAnchor: HTMLAnchorElement = <a href={app.resolveUrl(`~/api/documents/get/${model.id}`)} target="_blank" />
                    fakeAnchor.click();
                });
                return element;
            }
        });

        this.loadAndCreate();

        return div;

    }

    public render(): HTMLElement {
        this.element = this.getElement();
        this.props.widget.setGridPosition();
        return this.element;
    }
}